/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />
namespace TabAurous.OMS {
    var x;
    @Serenity.Decorators.registerClass()
    export class DesignBOMEditor extends _Ext.GridEditorBase<DesignBOMRow> {
        protected getColumnsKey() { return "OMS.DesignBOM"; }
        protected getDialogType() { return DesignBOMDialog; }
        protected getLocalTextPrefix() { return DesignBOMRow.localTextPrefix; }
        protected get_ExtGridOptions() { return Q.deepClone(q.DefaultEditorGridOptions) }
         
        protected form: DesignBOMForm;

        
        constructor(container: JQuery) { 
            super(container); 

            //this.form.ItemTypeId.changeSelect2(e => {
            //    var item = Q.toId(this.form.ItemTypeId.value);
            //    this.setFields(item);
            //});

        }

        protected getColumns() {

            var columns = super.getColumns(); 
            return columns;
        }
        public DisableAddButton() {
            this.toolbar.element.hide();
            this.element.hide();
        }

        public EnableAddButton() {
            this.toolbar.element.show();
            this.element.show();
            


        } 
        
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }

        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.RawMaterialMasterSelectGrid;
            // grid.apply(this.rowSelection = new Serenity.GridRowSelectionMixin(this));
            //grid.apply(this.getColumns = (Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));

            //buttons.push({
            //    title: "Pick Components",
            //    cssClass: "add-button",
            //    onClick: () => {
            //        var pickerDialog = new _Ext.GridItemPickerDialog({
            //            gridType: grid, multiple: true,
            //            preSelectedKeys: this.value.map(k => k.DesignId)
            //        });

            //        pickerDialog.onSuccess = (selectedItems: any[]) => {
            //            let selectedItems2 = selectedItems;
            //            //alert('Length' + selectedItems.length);
            //            var orddetails = [];
            //            var bomdetails = [];
            //            selectedItems2.forEach(function (value) {
            //                var prdid = value.DesignId;
            //                var atb = OMS.DesignRow.getLookup().itemById[prdid].AttributeId;
            //                let ATBDetails = OMS.CommonAttributesRow.getLookup().itemById[atb]

            //                var Pieces = OMS.DesignRow.getLookup().itemById[prdid].Pieces;
            //                var Weight = OMS.DesignRow.getLookup().itemById[prdid].Weight;
            //                var Rate = 0;
            //                if (ATBDetails.ItemTypeId == 104)
            //                     Rate = Q.first(OMS.MetalRateMasterRow.getLookup().items, x => x.MetalTypeId == ATBDetails.DesignTypeId && x.RateTypeId == 33
            //                        && x.CompanyId == Q.Authorization.userDefinition.CompanyId).Rate;
            //                if (ATBDetails.ItemTypeId  == 105)
            //                    Rate = RateHelper.GetStoneSalesRate(atb, 0);

            //                //var Amount = OMS.DesignRow.getLookup().itemById[prdid].A;

            //                var DesignBom: DesignBOMRow = {
            //                    BOMDesignId: prdid,
            //                    DesignCode: value.DesignCode,
            //                    BOMAttributeId: value.AttributeId,
            //                    Attribute: ATBDetails.Attribute,
            //                    ItemType: ATBDetails.ItemType,
            //                    ItemTypeId: ATBDetails.ItemTypeId,
            //                    CategoryId: ATBDetails.CategoryId,
            //                    SubCategoryCode: ATBDetails.SubCategoryCode,
            //                    StoneColorId: ATBDetails.StoneColorId,
            //                    MetalColorId: ATBDetails.MetalColorId,
            //                    KaratId: ATBDetails.KaratId,
            //                    KaratCode: ATBDetails.KaratCode,
            //                    BomRate: Rate,
            //                    Pieces: Pieces,
            //                    Weight: Weight,
            //                    CalcOnId: value.CalcOnId,
            //                    ShapeId: ATBDetails.ShapeId,
            //                    QualityId: ATBDetails.QualityId,
            //                    QualityCode: ATBDetails.QualityCode,
            //                    StdPurity: value.StdPurity,
            //                    BomAmount: value.CalcOnId == 3 ? Pieces * Rate||0 : Weight * Rate ||0
            //                };
            //                orddetails.push(DesignBom);

            //            });
                        
            //            //alert('Length details' + orddetails.length);
            //            for (let orderDetail of orddetails) {
            //                orderDetail[this.getIdProperty()] = "`" + this.nextId++;
            //                //alert('ID ' + orderDetail.PrdId);
            //                var x = orderDetail;
            //                this.view.addItem(orderDetail);

            //            }

            //        }

            //        pickerDialog.dialogOpen();
            //    }
            //});

            return buttons;
        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        validateEntity(row: DesignBOMRow, id: number) {
            if (!super.validateEntity(row, id))
                return false;


            //duplicate Component
            //row.BOMDesignId = Q.toId(row.BOMDesignId);

            //var sameDesign = Q.tryFirst(this.view.getItems(), x => x.BOMDesignId === row.BOMDesignId);
            //if (sameDesign && this.id(sameDesign) !== id) {
            //    Q.alert('This Component is already in Design details!');
            //   return false;
            //}

             //update values in grid

            //row.DesignCode = DesignRow.getLookup().itemById[row.BOMDesignId].DesignCode; 
            return true;
        }    


        protected setFields(ItemType: number) {

            switch (ItemType) {

                case 104: {
                    this.form.KaratId.getGridField().toggle(false);
                    this.form.Purity.getGridField().toggle(false);
                    this.form.MetalColorId.getGridField().toggle(false);
                    this.form.ShapeId.getGridField().toggle(true);
                    this.form.QualityId.getGridField().toggle(true);
                    this.form.StoneColorId.getGridField().toggle(true);
                    Serenity.EditorUtils.setRequired(this.form.Pieces, false);
                    break;
                    //Serenity.EditorUtils.se
                }
                case 105: {
                    this.form.KaratId.getGridField().toggle(true);
                    this.form.Purity.getGridField().toggle(true);
                    this.form.MetalColorId.getGridField().toggle(true);
                    this.form.ShapeId.getGridField().toggle(false);
                    this.form.QualityId.getGridField().toggle(false);
                    this.form.StoneColorId.getGridField().toggle(false);
                    Serenity.EditorUtils.setRequired(this.form.Pieces, true);
                    break;
                }

                default: {
                    this.form.KaratId.getGridField().toggle(true);
                    this.form.Purity.getGridField().toggle(true);
                    this.form.MetalColorId.getGridField().toggle(true);
                    this.form.ShapeId.getGridField().toggle(true);
                    this.form.QualityId.getGridField().toggle(true);
                    this.form.StoneColorId.getGridField().toggle(true);
                    Serenity.EditorUtils.setRequired(this.form.Pieces, false);
                    break;

                }

            }


        }

    }
}